import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
} from '@mui/material';
import client from '../../../../../API';

const headerSx = { '& th': { bgcolor: 'grey.100', color: 'text.primary', fontWeight: 600 } };

const UsersKPI = ({ setUserKpi }) => {
  const [data, setData] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const { mutate: fetchKPIs, isLoading, isError, error } = useMutation(
    client.users.userKPI,
    {
      onSuccess: (d) => {
        setData(d);
        const [currentWeek] = Object.keys(d).sort(
          (a, b) => new Date(b) - new Date(a)
        );
        setUserKpi({ progress: d[currentWeek]?.new_users || 0 });
      },
    }
  );

  useEffect(fetchKPIs, []);

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {error.message}</div>;

  const sorted = Object.entries(data).sort(
    (a, b) => new Date(b[0]) - new Date(a[0])
  );

  return (
    <Paper elevation={2}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead sx={headerSx}>
            <TableRow>
              <TableCell>Week Starting</TableCell>
              <TableCell>New Users</TableCell>
              <TableCell>Logins</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {sorted
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(([week, d]) => (
                <TableRow key={week}>
                  <TableCell>{week}</TableCell>
                  <TableCell>{d.new_users}</TableCell>
                  <TableCell>{d.logins}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25]}
        count={sorted.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
      />
    </Paper>
  );
};

export default UsersKPI;
